import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { RpaBotsService } from 'app/rpa-bots/core/rpa-bots.service';
import {
  EBluePrismConnActions,
  BluePrismConnList,
  BluePrismConnListSuccess,
  UpdateBluePrismConn,
  UpdateBluePrismConnSuccess,
  getCurrentBluePrismConn,
  getCurrentBluePrismConnSuccess,
  ShowSuccessToast,
  TestBluePrismConnSuccess,
  TestBluePrismConn
} from 'app/rpa-bots/blue-prism/store/actions/rpa-blueprism-conn.actions';
import { switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from 'app/IAppState';
import { IRpaConnectionBluePrism } from 'app/rpa-bots/core/IRpaBots';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Injectable()
export class BluePrismConnEffects {

  getBluePrismConnList$ = createEffect(() =>
    this._actions$.pipe(
      ofType<BluePrismConnList>(EBluePrismConnActions.BluePrismConnList),
      switchMap(() => this._rpaBotsService.getConnectionsBluePrism()),
      switchMap((connectors: IRpaConnectionBluePrism[]) =>
        of(new BluePrismConnListSuccess(connectors))
      )
    )
  );
  updateBluePrismConn$ = createEffect(() =>
    this._actions$.pipe(
      ofType<UpdateBluePrismConn>(EBluePrismConnActions.UpdateBluePrismConn),
      switchMap(param =>
        this._rpaBotsService.updateConnectionBluePrism(param.payload)
      ),
      switchMap(() => [
        new UpdateBluePrismConnSuccess(),
        new ShowSuccessToast(),
        new BluePrismConnList()
      ])
    )
  );
  currentBluePrismConn$ = createEffect(() =>
    this._actions$.pipe(
      ofType<getCurrentBluePrismConn>(
        EBluePrismConnActions.getCurrentBluePrismConn
      ),
      switchMap(param =>
        this._rpaBotsService.getConnectionBluePrism(param.payload)
      ),
      switchMap((connector: IRpaConnectionBluePrism) =>
        of(new getCurrentBluePrismConnSuccess(connector))
      )
    )
  );
  testBluePrismConnection$ = createEffect(() =>
    this._actions$.pipe(
      ofType<TestBluePrismConn>(EBluePrismConnActions.TestBluePrismConn),
      switchMap(param =>
        this._rpaBotsService.testConnectionBluePrism(param.payload)
      ),
      switchMap(() => {
        this._showToastService.showToast(this._i18nService.instant('RPA_BOTS.TEST_CONNECTION_SUCCESS'), 'success');
        return of(new TestBluePrismConnSuccess());
      }),
      catchError((error, caught) => {
        this._store.dispatch(new TestBluePrismConnSuccess());
        return caught;
      })
    )
  );


  showSuccessToast$ = createEffect(() =>
    this._actions$.pipe(
      ofType<ShowSuccessToast>(EBluePrismConnActions.ShowSuccessToast),
      switchMap(() => {
        this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
        return of(new ShowSuccessToast());
      })
    )
  );

  constructor(
    private _rpaBotsService: RpaBotsService,
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _translateService: TranslateService,
    private _i18nService: I18nService,
    private _toastService: BzgToastService,
    private _showToastService: ShowToastService
  ) {
  }
}
